export function getAppConfig() {
  return window.__APP_CONFIG__ || {};
}

export function getApiBase() {
  const { baseApi } = getAppConfig();
  return baseApi || "http://localhost:5000";
}

export function withBase(pathOrUrl) {
  const b = getApiBase();
  const s = String(pathOrUrl || "");
  return s.startsWith("http") ? s : `${b}${s}`;
}
